import routes from './routes';
import { SetRoutes } from 'components';

const InvoicesAtvVillagePages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default InvoicesAtvVillagePages;
